import { http } from "services/http";

import type {
  Agent,
  AgentsListRequest,
  AgentsListResponse,
  AiPercentsRequest,
  AiTradesConfiguration,
  AiTradesDestroyRequest,
  AiTradesRequest,
  AiTradesResponse,
  ConditionsDestroyRequest,
  ConditionsSaveRequest,
  Deal,
  DealsListRequest,
  DealsListResponse,
  DealStoreRequest,
  DealUpdateRequest,
  FindDealsRequest,
  SlugsRequest,
  TradesConfiguration,
  TradesIdRequest,
  TradesIdResponse,
  TradeSlug,
} from "models/trades.model";

const multipart = { headers: { contentType: "multipart/form-data" } };

export const tradesApi = {
  getData: (data?: DealsListRequest) =>
    http.quiet().post<DealsListResponse>("/api/trades-history", data ? { ...data } : null),
  getSlugs: (data?: SlugsRequest) =>
    http.quiet().post<TradeSlug[]>("/api/trades-history/get-slugs", data ? { ...data } : null),
  createDeals: (data: FindDealsRequest) =>
    http.quiet().post("/api/trades-history/find-deals", { ...data }),
  createDeal: (data: DealStoreRequest) =>
    http.quiet().post<TradesIdResponse>("/api/trades-history/store", { ...data }),
  getDeal: (data: TradesIdRequest) => http.quiet().post<Deal>("/api/trades-history/show", { ...data }),
  updateDeal: (data: DealUpdateRequest) =>
    http.quiet().post<TradesIdResponse>("/api/trades-history/update", { ...data }),
  destroyTradesHistory: () => http.quiet().post("/api/trades-history/destroy", {}),

  getAgents: (data?: AgentsListRequest) =>
    http.quiet().post<AgentsListResponse>("/api/trades-history-agents", data ? { ...data } : null),
  // name, operational_days[], times, amounts, success rates, data (JSON) and the
  // avatar file appended to a FormData; `update` adds the id.
  addAgent: (data: FormData) =>
    http.quiet().post<TradesIdResponse>("/api/trades-history-agents/store", data, multipart),
  showAgent: (data: TradesIdRequest) =>
    http.quiet().post<Agent>("/api/trades-history-agents/show", { ...data }),
  updateAgent: (data: FormData) => http.quiet().post("/api/trades-history-agents/update", data, multipart),
  destroyAgent: (data: TradesIdRequest) =>
    http.quiet().post("/api/trades-history-agents/destroy", { ...data }),

  tradesHistoryConfiguration: () =>
    http.quiet().post<TradesConfiguration>("/api/trades-history-configuration", {}),
  tradesHistoryConfigurationStore: (data: ConditionsSaveRequest) =>
    http.quiet().post<TradesIdResponse>("/api/trades-history-configuration/store", { ...data }),
  tradesHistoryConfigurationUpdate: (data: ConditionsSaveRequest) =>
    http.quiet().post<TradesIdResponse>("/api/trades-history-configuration/update", { ...data }),
  tradesHistoryConfigurationDestroy: (data: ConditionsDestroyRequest) =>
    http.quiet().post("/api/trades-history-configuration/destroy", { ...data }),

  tradesHistoryAI: (data?: AiTradesRequest) =>
    http.quiet().post<AiTradesResponse>("/api/trades-history/ai", data ? { ...data } : {}),
  tradesHistoryAIConfiguration: () =>
    http.quiet().post<AiTradesConfiguration>("/api/trades-history/ai-config", {}),
  tradesHistoryAIConfigurationStore: (data: ConditionsSaveRequest) =>
    http.quiet().post<TradesIdResponse>("/api/trades-history/ai-config/store", { ...data }),
  tradesHistoryAIConfigurationUpdate: (data: ConditionsSaveRequest) =>
    http.quiet().post<TradesIdResponse>("/api/trades-history/ai-config/update", { ...data }),
  tradesHistoryAIConfigurationDestroy: (data: ConditionsDestroyRequest) =>
    http.quiet().post("/api/trades-history/ai-config/destroy", { ...data }),
  destroyTradesHistoryAi: (data: AiTradesDestroyRequest) =>
    http.quiet().post("/api/trades-history/ai/destroy", { ...data }),
  tradesHistoryAIConfigurationPercents: (data: AiPercentsRequest) =>
    http.quiet().post("/api/trades-history/ai-config/percents", { ...data }),
};
